import React, { useState } from "react";
import styles from "./ProductsImages.module.scss";
import DynamicFilterBar from "../../../../common/AdminCommonComponents/FilterBars/DynamicFilterBar/DynamicFilterBar";
import DesignGrid from "../DesignGrid/DesignGrid";
import { gifImagesData, jpjImagesData, pngImagesData } from "../designData";

const tabsData = [
    { key: "1", label: "JPJ" },
    { key: "2", label: "PNG" },
    { key: "3", label: "GIF" },
];

const ProductsImages = () => {
    const [activeTab, setActiveTab] = useState(tabsData[0]?.key || "");

    return (
        <div className={styles.productImagesContainer}>
            <div className={styles.tabContainer}>
                <DynamicFilterBar
                    filterTabs={tabsData}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    barType="dark-borderless"
                />
            </div>

            <DesignGrid
                data={activeTab === "1" ? jpjImagesData : activeTab === "2" ? pngImagesData : gifImagesData}
                layout={"Portrait"}
            />
        </div>
    );
};

export default ProductsImages;